export const editPhoneDialogSx = {
  content: {
    pt: 1,
  },
  actions: {
    px: 2,
    pb: 2,
    gap: 1,
  },
  intro: {
    mb: 2,
    "& strong": {
      fontWeight: 700,
    },
  },
  phoneField: {
    width: "100%",
    mt: 1,
    "& .react-international-phone-input-container": {
      width: "100%",
    },
    "& .react-international-phone-input": {
      flex: 1,
      minWidth: 0,
    },
  },
  previewLabel: {
    mt: 2,
    display: "block",
  },
  preview: {
    fontFamily: "monospace",
    fontWeight: 600,
    wordBreak: "break-all",
  },
  error: {
    mt: 0.5,
    display: "block",
  },
};
